import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { GetTotalAppointmentAction } from "../../redux/actions/InsBillAction";
import { TotalProveiderMonth } from "../NetworkPortal/PayOut/helper";
import { payOutHeaderValue } from "../NetworkPortal/PayOut/AdditionalApptHeader";
import CustomPagination from "../../common/CustomPagination";

export const InsUnsuccessfullAppt = ({
  searchFilter,
  providerDetail,
  setProviderDetail,
  setSearchFilter,
  header,
  setSelectAllFlag,
  setSelectAll,
  showData,
  setShowData,
  insBillReducer,
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const [tableIndex, setTableIndex] = useState(null);

  useEffect(() => {
    dispatch(
      GetTotalAppointmentAction({
        ...searchFilter,
        IsPayoutStatus: false,
        page: 1,
        rows:10
      })
    );
  }, []);
  return (
    <>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    insBillReducer?.getInsAppointmentDetail?.length ===
                    providerDetail?.length
                  }
                  onClick={(e) => {
                    if (e.target.checked) {
                      setProviderDetail(
                        insBillReducer?.getInsAppointmentDetail
                      );
                      setSelectAllFlag(true);
                    } else {
                      setSelectAll(false);
                      setProviderDetail([]);
                      setSelectAllFlag(false);
                    }
                  }}
                  readOnly
                />
              </th>
              
              <th >Insurer Name</th>
              <th >Policy Ref No</th>
              <th >Case No</th>
              <th style={{textAlign:"center"}}>Insurer Amount</th>
              <th>GST</th>
              {header.map((ele) => {
                return (
                  <th
                    className={`${
                      ele === "Additional Test" ||
                      ele === "Tests" ||
                      ele === "Test Details"
                        ? "financeAdditionalTest"
                        : "addHeader"
                    }`}
                  >
                    {ele}
                  </th>
                );
              })}
            </tr>
          </thead>
          {insBillReducer?.getInsAppointmentDetail?.length !== 0 && (
            <tbody>
              {insBillReducer?.getInsAppointmentDetail?.map(
                (ele, itemIndex) => {
                  return (
                    <tr key={itemIndex}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={providerDetail.some((item) => ele === item)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setProviderDetail([...providerDetail, ele]);
                            } else {
                              setSelectAllFlag(false);
                              setSelectAll(false);
                              setProviderDetail(
                                providerDetail?.filter((item) => ele !== item)
                              );
                            }
                          }}
                          readOnly
                        />
                      </td>
                      <td style={{ minWidth: "200px" }}>{ele?.clientName}</td>
                      <td >
                        {ele?.policyRefNo}
                      </td>
                      <td style={{ minWidth: "100px" }}>
                        {ele?.caseNo}
                      </td>
                      {/* <td style={{ minWidth: "200px" }}>{ele?.proposerName}</td> */}
                      <td style={{ textAlign: "center", minWidth: "130px" }}>
                        {ele?.insurerSum?.toLocaleString('en-IN')}
                      </td>
                      <td>{ele?.gst?.toLocaleString('en-IN')}</td>
                      {header.map((col) => {
                        return (
                          <td
                            className={`${
                              col === "Test Details"
                                ? "financeAdditionalTest"
                                : "addHeader"
                            }`}
                          >
                            {col === "Test Details" &&
                            ele[payOutHeaderValue[col]] !== null ? (
                              <>
                                {showData === true && tableIndex === itemIndex
                                  ? ele[payOutHeaderValue[col]]
                                  : ele[payOutHeaderValue[col]]
                                      .split(" ")
                                      ?.slice(0, 10)
                                      ?.join(" ")}
                                <a
                                  id="payOutShowMoreBtn"
                                  onClick={() => {
                                    if (col === "Test Details") {
                                      // setShowData(!showData);
                                      setTableIndex(itemIndex);
                                      setShowData(
                                        showData && tableIndex === itemIndex
                                          ? false
                                          : true
                                      );
                                    }
                                  }}
                                >
                                  {ele[payOutHeaderValue[col]].split(" ")
                                    .length < 20
                                    ? ""
                                    : showData === true &&
                                      tableIndex === itemIndex
                                    ? " view less"
                                    : "...view more"}
                                </a>
                              </>
                            ) : col === "Appointment Closed Date" ? (
                              moment(ele?.appointmentClosedDate).format("ll")
                            ) : col === "Month" ? (
                              TotalProveiderMonth(ele?.year, ele?.month)
                            ) 
                            : col === "GST" ||
                            col === "Service Charges" ||
                            col === "Home Visit Amount" ||
                            col === "Adjustment Amount" ||
                            col === "Gross Amount" ? 
                            ele[payOutHeaderValue[col]]?.toLocaleString(
                              "en-IN"
                            )
                             : (
                              ele[payOutHeaderValue[col]]
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                }
              )}
            </tbody>
          )}
        </table>
        {insBillReducer?.getInsAppointmentDetail?.length === 0 && (
          <p className="noRecordFound">No Record Found</p>
        )}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetTotalAppointmentAction}
              IsPayoutStatus={false}
            />
          )}
        </div>
      </div>
    </>
  );
};
